<template>
  <div class="ParameterDetails">
    <div v-if="!parameter">
      <b-container fluid="xxl">
        <b-row class="justify-content-md-center">
            <b-col class="mt-5">
              <div class="spinner-border m-5" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </b-col>
        </b-row>
      </b-container>
    </div>
    <div v-else>
      <b-container fluid="xxl">
        <b-row>
          <b-col class="pl-0">
            <PageTitle v-if="parameterBinData" v-bind:title="parameter.name" :pretitle="'Parameter Details'" />
          </b-col>
        </b-row>
        <b-row class="justify-content-md-center">
          <b-col>
            <article>
              <b-row>
                <b-col>
                  <h6>Comment</h6>
                  <span v-html="parameter.comment"></span>
                </b-col>
              </b-row>
            </article>
          </b-col>
        </b-row>

        <b-row style="margin-top:10px">
          <b-col cols="4">
            <h6>Bins</h6>
            <Select2
              :options="parameter.bins"
              ref="select2"
              @select="setBin($event)"
              tabindex="0"
            />
          </b-col>
        </b-row>

        <hr>

        <DMSOccurrencesTable
          style="margin-top: 30px;"
          :context="parameterBinData"
          :viewOnly="true"
          @update="loadTokensParameterBin"
          v-if="parameterBinData && parameterBinData.results"
        />
      </b-container>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import PageTitle from '@/components/PageTitle.vue'
  import DMSOccurrencesTable from "@/views/doc/DMSOccurrencesTable.vue"
  import config from '@/config.js'
  import Select2 from 'v-select2-component'

  export default {
    name: 'ParameterDetails',
    data() {
      return {
        parameterId: this.$route.params.parameterId,
        parameter: null,
        parameterBinData: {},
        index: 0,
        config: config,
        bin: null
      }
    },
    components: {
      DMSOccurrencesTable,
      PageTitle,
      Select2
    },
    mounted() {
      axios
        .get(config.apiUrl + '/parameter/info/' + this.parameterId)
        .then((response) => {
          this.parameter = response.data
        })
    },
    methods: {
      async loadTokensParameterBin() {
        const parameters = {parameterId: this.parameterId, bin: this.bin}
        await this.$store.dispatch('loadTokensParameterBin', parameters).then(result => {
          this.parameterBinData = result.data
        })
      },
      setBin(event) {
        this.bin = event.text
      }
    },
    watch: {
      "bin"(){
        this.loadTokensParameterBin()
      }
    }
  }
</script>

